import { render, staticRenderFns } from "./StudentFooter.vue?vue&type=template&id=89dca942&scoped=true&"
import script from "./StudentFooter.vue?vue&type=script&lang=js&"
export * from "./StudentFooter.vue?vue&type=script&lang=js&"
import style0 from "./StudentFooter.vue?vue&type=style&index=0&id=89dca942&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89dca942",
  null
  
)

export default component.exports